import axios from 'axios'

const isProduction = process.env.NODE_ENV === 'production'

const elem = document.getElementById('rs-frontend-app')
const RS_REST_API_NONCE = elem.dataset.restApiNonce

export const createApi = () => {
  const api = axios.create({
    baseURL: `${isProduction ? '' : 'http://tour-booking-engine.local'}/wp-json/tbengine/client/v1/`
  })

  api.interceptors.request.use((request) => {
    if (isProduction) request.headers.common['X-WP-Nonce'] = RS_REST_API_NONCE

    return request
  })

  return api
}
